import {HttpClient, HttpParams, HttpResponse} from "@angular/common/http";
import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {environment} from "@env/environment";
import {LeasePos} from "./lease-pos.model";

@Injectable({
  providedIn: 'root'
})
export class LeasePosService {

  constructor(private http: HttpClient) { }

  getLeasePosData(): Observable<LeasePos[]> {
    let requestParams = new HttpParams()
      .set('transactionSource', 'VEND');
    return this.http.get<LeasePos[]>(this.baseLeaseUrl + '/configs', {params: requestParams});
  }

  downloadPosDataForConfig(request: { config: LeasePos, dataTypes: string[] }): Observable<HttpResponse<ArrayBuffer>> {
    const options = {responseType: 'arraybuffer' as 'json', observe: 'response'};
    // @ts-ignore
    return this.http.post<HttpResponse<ArrayBuffer>>(this.baseLeaseUrl + '/vend', request, options);
  }

  get baseLeaseUrl() {
    return environment.apiProductsHost + `/console/transaction-source/payload`
  }
}
